import { render, staticRenderFns } from "./dashLog.vue?vue&type=template&id=80099488&scoped=true"
import script from "./dashLog.vue?vue&type=script&lang=js"
export * from "./dashLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80099488",
  null
  
)

export default component.exports